"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.color = exports.CommonTokenInjector = void 0;
var _core = require("@emotion/core");
var _designTokens = require("@smartsheet/design-tokens");
var _react = _interopRequireWildcard(require("react"));
var _ThemeMarkerAttribute = require("./ThemeMarkerAttribute");
var _createTokenInjector = require("./createTokenInjector");
const BACKGROUND_COLOR_TRANSITION_MILLISECONDS = 200;
const {
  getToken,
  Injector
} = (0, _createTokenInjector.createTokenInjector)({
  tokens: _designTokens.commonTokens,
  supportedThemes: ["lodestar-light", "ursa-light", "ursa-dark"],
  namespace: "com"
});
const CommonTokenInjector = _ref => {
  let {
    themeKey
  } = _ref;
  const [_actualThemeKey, setActualThemeKey] = (0, _react.useState)(themeKey);
  const [applyBackgroundColorTransition, setApplyBackgroundColorTransition] = (0, _react.useState)(false);

  // Users should get the right theme immediately. This helps w/ tests and the initial paint.
  const firstMountRef = (0, _react.useRef)(true);
  if (firstMountRef.current) {
    document.body.setAttribute(_ThemeMarkerAttribute.BODY_MARKER_ATTRIBUTE, themeKey);
    firstMountRef.current = false;
  }
  (0, _react.useLayoutEffect)(() => {
    let animationTimeoutId = 0;
    setApplyBackgroundColorTransition(true);
    // We want to apply the CSS change after a tick to ensure all the React stuff has settled
    // first.
    const rafId = requestAnimationFrame(() => {
      setActualThemeKey(themeKey);
      animationTimeoutId = window.setTimeout(() => {
        setApplyBackgroundColorTransition(false);
      }, BACKGROUND_COLOR_TRANSITION_MILLISECONDS);
      document.body.setAttribute(_ThemeMarkerAttribute.BODY_MARKER_ATTRIBUTE, themeKey);
    });
    return () => {
      cancelAnimationFrame(rafId);
      clearTimeout(animationTimeoutId);
    };
  }, [themeKey]);

  // When this component is unmounted, we should remove the attribute to clean up.
  (0, _react.useEffect)(() => () => {
    document.body.removeAttribute(_ThemeMarkerAttribute.BODY_MARKER_ATTRIBUTE);
  }, [themeKey]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Injector, {
    themeKey: themeKey
  }), /*#__PURE__*/_react.default.createElement(_core.Global, {
    styles: {
      // This should only be added when the themeKey is transitioning or
      // it affects everything else pretty badly.
      "*, *:before, *.after": applyBackgroundColorTransition ? {
        transition: `
                    background-color ${BACKGROUND_COLOR_TRANSITION_MILLISECONDS}ms linear,
                    border-color ${BACKGROUND_COLOR_TRANSITION_MILLISECONDS}ms linear,
                    color ${BACKGROUND_COLOR_TRANSITION_MILLISECONDS}ms linear
                    `
      } : {}
    }
  }));
};
exports.CommonTokenInjector = CommonTokenInjector;
const color = getToken;
exports.color = color;
//# sourceMappingURL=CommonTokenInjector.js.map